module.exports = __webpack_public_path__ + "img/1565357122.e9d73127.jpg";